<div>
    <div *ngIf="!openQueueForm">
        <div class="Tabletitle">
            <span class="Tabletitle"> Queues ({{queuesCount}})</span>
        </div>

        <div class="row" *ngIf="allQueues">
            <button class="actionButton m-1" mat-raised-button (click)="openNewQueueForm($event)">Create
                Queue</button>
                <div class="input-group-sm mt-2 input-group col-6">
                    <input *ngIf="allQueues" class="form-control" type="search" (keyup)="applyFilter($event)" placeholder="Filter">
                </div>
        </div>

        <div *ngIf="!allQueues && noQueues">
            No Queues to display
        </div>

        <div *ngIf="allQueuesDataSource" class="table-container mat-elevation-z8">
            <table mat-table matSort [dataSource]="allQueuesDataSource" matSortActive="createdate" matSortDirection="desc"
                aria-describedby="queue-table">

                <ng-container matColumnDef="queue_name">
                    <th id="queueName" mat-header-cell *matHeaderCellDef mat-sort-header> Queue Name </th>
                    <td mat-cell *matCellDef="let queue"> {{queue.queue}} </td>
                </ng-container>

                <ng-container matColumnDef="queue_groups">
                    <th id="queueGroups" mat-header-cell *matHeaderCellDef mat-sort-header> Queue Groups </th>
                    <td mat-cell *matCellDef="let queue"> {{queue.groups}} </td>
                </ng-container>

                <ng-container matColumnDef="createdby">
                    <th id="createdby" mat-header-cell *matHeaderCellDef mat-sort-header> Created By </th>
                    <td mat-cell *matCellDef="let queue"> {{queue.createdby}} </td>
                </ng-container>

                <ng-container matColumnDef="createdate">
                    <th id="createdate" mat-header-cell *matHeaderCellDef mat-sort-header> Create On </th>
                    <td mat-cell *matCellDef="let queue"> {{queue.createdate | date}} </td>
                </ng-container>

                <ng-container matColumnDef="queue_status">
                    <th id="queueStatus" mat-header-cell *matHeaderCellDef mat-sort-header> Active </th>
                    <td mat-cell *matCellDef="let queue">
                        <mat-icon *ngIf="queue.status">check</mat-icon>
                    </td>
                </ng-container>

                <ng-container matColumnDef="actions">
                    <th id="action" mat-header-cell *matHeaderCellDef mat-sort-header> Actions </th>
                    <td mat-cell *matCellDef="let queue">
                        <mat-icon title="Update Queue" (click)="openUpdateQueueForm($event, queue)">edit
                        </mat-icon>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

            </table>
            <mat-paginator [pageSizeOptions]="[10, 20, 50]" [pageSize]="10" showFirstLastButtons></mat-paginator>
        </div>
    </div>

    <div *ngIf="openQueueForm">
        <div class="sticky-top">
            <div *ngIf="queueData.title=='Update Queue'" class="Tabletitle">{{queueData.title}} -
                {{queueData.name}}</div>
            <div *ngIf="queueData.title=='Create Queue'" class="Tabletitle">{{queueData.title}}</div>
        </div>
        <div *ngIf="!queueCreated && !queueUpdated">
            <form #queueForm="ngForm">
                <div class="card-body">
                    <div class="row">
                        <div class="input-group-sm mb-3 input-group col-6">
                            <div class="input-group-prepend">
                                <span class="input-group-text form-label-105">Queue Name</span>
                            </div>
                            <input name="queue_name" class="form-control" type="text" [(ngModel)]="queueData.name"
                                required>
                        </div>

                        <div class="input-group-sm mb-3 input-group col-6">
                            <div class="input-group-prepend">
                                <span class="input-group-text form-label-105">SLA (Days)</span>
                            </div>
                            <input name="queue_action_sla" type="number" [(ngModel)]="queueData.sla" class="form-control" required>
                        </div>

                        <div class="input-group-sm mb-3 input-group col-6">
                            <div class="input-group-prepend">
                                <span class="input-group-text form-label-105">Queue Groups</span>
                            </div>
                            <mat-select [(ngModel)]="queueData.groups" multiple name="groups"
                                class="form-control" required>
                                <mat-option>
                                    <ngx-mat-select-search [(ngModel)]="searchCtrl" [placeholderLabel]="'Search...'"
                                        [noEntriesFoundLabel]="'Not found'" name="search"
                                        [ngModelOptions]="{standalone: true}">
                                    </ngx-mat-select-search>
                                </mat-option>
                                <mat-option *ngFor="let user of usersList | stringFilter:searchCtrl:'name'"
                                    [value]="user">
                                    {{user}}
                                </mat-option>
                            </mat-select>
                        </div>

                        <div class="input-group-sm mb-3 input-group col-6">
                            <div class="input-group-prepend">
                                <span class="input-group-text">Supervisor Groups</span>
                            </div>
                            <mat-select [(ngModel)]="queueData.supervisor_groups" multiple name="supervisor_groups"
                                class="form-control">
                                <mat-option>
                                    <ngx-mat-select-search [(ngModel)]="searchCtrl" [placeholderLabel]="'Search...'"
                                        [noEntriesFoundLabel]="'Not found'" name="search"
                                        [ngModelOptions]="{standalone: true}">
                                    </ngx-mat-select-search>
                                </mat-option>
                                <mat-option *ngFor="let user of usersList | stringFilter:searchCtrl:'name'"
                                    [value]="user">
                                    {{user}}
                                </mat-option>
                            </mat-select>
                        </div>
                    </div>

                    <div class="row">
                        <div class="input-group-sm mb-3 input-group col-6">
                            <div class="input-group-prepend">
                                <span class="input-group-text form-label-105">Assign</span>
                            </div>
                            <mat-select name="queue_action_assign" [(ngModel)]="queueData.assign"
                                class="form-control" multiple >
                                <span *ngFor="let queue of allQueues">
                                    <mat-option *ngIf="queue.queue!=queueData.queue"
                                        [value]="queue.queue">
                                        {{queue.queue}}
                                    </mat-option>
                                </span>
                            </mat-select>
                        </div>

                        <div class="input-group-sm mb-3 input-group col-6">
                            <div class="input-group-prepend">
                                <span class="input-group-text">Default Next Queue</span>
                            </div>
                            <mat-select name="queue_default_assign" [(ngModel)]="queueData.default"
                                class="form-control">
                                <span *ngFor="let queue of queueData.assign">
                                    <mat-option *ngIf="queue!=queueData.queue"
                                        [value]="queue">
                                        {{queue}}
                                    </mat-option>
                                </span>
                            </mat-select>
                        </div>
                    </div>

                    <div class="row">
                        <div class="input-group-sm mb-3 input-group col-6">
                            <div class="input-group-prepend">
                                <span class="input-group-text form-label-105">Categories</span>
                            </div>
                            <mat-select name="categories" [(ngModel)]="queueData.queue_action.categories"
                                (selectionChange)="getDisplayLabelstData(queueData.queue_action.categories)"
                                (ngModelChange)="queueData.queue_action.categories" class="form-control" multiple>
                                <mat-option>
                                    <ngx-mat-select-search [(ngModel)]="searchCtrl" [placeholderLabel]="'Search...'"
                                        [noEntriesFoundLabel]="'Not found'" name="search"
                                        [ngModelOptions]="{standalone: true}">
                                    </ngx-mat-select-search>
                                </mat-option>
                                <mat-option
                                    *ngFor="let category of allCategories.results |stringFilter:searchCtrl:'name'"
                                    [value]="category.id">
                                    {{category.name}}
                                </mat-option>
                            </mat-select>
                        </div>

                        <div *ngIf="queueData.queue_action.categories.length>0" class="input-group-sm mb-3 input-group col-6">
                            <div class="input-group-prepend">
                                <span class="input-group-text form-label-105">Attributes</span>
                            </div>
                            <mat-select name="queue_labels" [(ngModel)]="queueData.queue_attributes"
                                class="form-control" multiple>
                                <mat-option *ngFor="let queueLabel of allQueueLabels |stringFilter:searchCtrl:'name'"
                                    [value]="queueLabel.value">
                                    {{queueLabel.name}}
                                </mat-option>
                            </mat-select>
                        </div>

                        <div *ngIf="queueData.queue_action.categories.length==0" class="input-group-sm mb-3 input-group col-6">
                            <div class="input-group-prepend">
                                <span class="input-group-text form-label-105">Attributes</span>
                            </div>
                            <mat-select name="queue_labels" [(ngModel)]="queueData.queue_attributes"
                                class="form-control" multiple>
                                <mat-option *ngFor="let queueLabel of allQueueLabels |stringFilter:searchCtrl:'name'"
                                    [value]="queueLabel">
                                    {{queueLabel}}
                                </mat-option>
                            </mat-select>
                        </div>
                    </div>

                    <div class="row">
                        <div class="input-group-sm mb-3 input-group col-6">
                            <div class="input-group-prepend">
                                <span class="input-group-text">Completion Options</span>
                            </div>
                            <mat-select name="complete_options" [(ngModel)]="queueData.complete_options"
                            class="form-control" multiple>
                                <mat-option *ngFor="let option of completeOptions |stringFilter:searchCtrl:'name'"
                                    [value]="option">
                                    {{option}}
                                </mat-option>
                            </mat-select>
                        </div>

                        <div class="input-group-sm mb-3 input-group col-6">
                            <div class="input-group-prepend">
                                <span class="input-group-text">Termination Options</span>
                            </div>
                            <mat-select name="terminate_options" [(ngModel)]="queueData.terminate_options"
                            class="form-control" multiple>
                                <mat-option *ngFor="let option of terminateOptions |stringFilter:searchCtrl:'name'"
                                    [value]="option">
                                    {{option}}
                                </mat-option>
                            </mat-select>
                        </div>
                    </div>

                    <div style="float: right;">
                        <button mat-raised-button *ngIf="queueData.button=='Create'" class="actionButton m-2"
                            (click)="createQueueHandler()" [disabled]="!queueForm.valid">{{queueData.button}}</button>
                        <button mat-raised-button *ngIf="queueData.button=='Update'" class="actionButton m-2"
                            (click)="updateQueueHandler()" [disabled]="!queueForm.valid">{{queueData.button}}</button>
                        <button mat-raised-button class="backButton m-2" (click)="displayPage()">Back</button>
                    </div>
                </div>
            </form>
        </div>

        <div class="card mt-5" *ngIf="queueCreated">
            <div class="card-body">

                <div>Queue <strong>{{queueData.queue_name}} </strong>has been created.</div>
                <button class="backButton float-right m-1" mat-raised-button (click)="displayPage()">Back</button>

            </div>
        </div>
        <div class="card mt-5" *ngIf="queueUpdated">
            <div class="card-body">

                <div>Queue <strong>{{queueData.queue_name}} </strong>has been updated.</div>
                <button class="backButton  float-right m-1" mat-raised-button (click)="displayPage()">Back</button>

            </div>
        </div>
    </div>
</div>